import usheLogo from '@images/ushe-logo.png';

import { StyledUsheIcon } from './UsheIcon.styles';

interface UsheIconProps {
  size?: number;
}

export const UsheIcon = ({ size = 14 }: UsheIconProps) => (
  <StyledUsheIcon aria-hidden="true">
    <img src={usheLogo} alt="" width={size} height={size} />
  </StyledUsheIcon>
);
